
<script setup>
import contentsComponent from '@/components/PageComponents/Contents.vue'
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import DefaultPreFooter from '@/layouts/default/PreFooter.vue'
import { useHead, useSeoMeta } from '@unhead/vue'
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ref, watch } from 'vue'
import { useLocale } from 'vuetify';
import { useGtm } from '@gtm-support/vue-gtm';
const gtm = useGtm();

const env = import.meta.env

const { t } = useLocale()
const store = useStore()
const single = ref()
const route = useRoute();    
// const referr = (document.referrer) ? document.referrer : window.frames.top.document.referrer;
  

const setPageSingle = async (route) => {

  let slug = route.path;


  if(slug.endsWith('/')){
    slug = route.path.slice(0, -1);
  }

  if(route.name == 'Home'){
    slug = '/'
  }

  if(route.name == 'search'){
    slug = '/search'
  }

  if(slug == '/it' || slug == '/en'|| slug == '/pt' || slug == '/ru'){

    slug = '/home-page'

    // if(referr.includes('facebook') || referr.includes('instagram') || referr.includes('twitter') || referr.includes('pinterest') || referr.includes('tiktok')){
    //  slug = '/home-prospect'
    // }
    
    if(localStorage.getItem('authenticated') == "true"){
      slug = '/home-loyalty'
    }    
    
  }
 
  let data =  await store.dispatch('pages/getSingle',{slug:slug})

  single.value =  data.data

  let page = single.value
      
      

      let links = [];

      var listOfLinks =document.head.querySelectorAll("link[hreflang]");
      if(listOfLinks){
        for (var i = 0; i < listOfLinks.length; i++) {
          document.head.removeChild(listOfLinks[i]);
        }
      }
      
     

      let canonical = 'https://' + location.host + page.full_slug;
      links.push({rel: 'canonical', href: canonical});


      Object.keys(page.translated_slugs).forEach((lang) => {
        let locale_slug = page.translated_slugs[lang];
        let link =  {
          rel: 'alternate',
          hreflang: lang,
          href: location.protocol + '//' + location.host+locale_slug
        }
        links.push(link);
      });
      
      
      // solo in produzione vera no in pre-prod
      let robotsContent = "noindex, nofollow";
       if(env.VITE_NODE_ENV == 'production'){
        robotsContent = page.indexable ? page.indexable : "noindex, nofollow";
       }
      page.meta.push({name: 'robots', content: robotsContent});

      // console.log('page.meta',page.meta)
      
      useHead({
        title: page.title,
        meta: page.meta,
        link: links,
        htmlAttrs: {
          lang: page.locale,
        }
      })

      useSeoMeta({
        title: page.title,
        ogTitle: page.title,
        description: page.description,
        ogDescription: page.description,
        ogUrl: location.href,
        ogImage: (page.thumbnail) ? page.thumbnail.url : 'https://s3.eu-west-1.amazonaws.com/web.dmcs.a-tono.net/primerentcar/storage/local/primerent.webp',
        twitterCard: 'summary_large_image',
        twitterImage: (page.thumbnail) ? page.thumbnail.url : 'https://s3.eu-west-1.amazonaws.com/web.dmcs.a-tono.net/primerentcar/storage/local/primerent.webp',
        twitterTitle: page.title,
        twitterDescription: page.description,
      })

      gtm.trackView( page.title, page.full_slug );
      

      if(page.class == 'home'){
        
        gtm.trackEvent({
          event:'view_home',
          tipo: page.title
        });

      }

      if(page.class == "car_archive"){
        gtm.trackEvent({
          event:'view_brand',
          tipo: page.title 
        })
      }

      store.dispatch('loading/set',false);
      return true;

};

let immediate = true
let loadedpage = sessionStorage.getItem('loadedpage') ? JSON.parse(sessionStorage.getItem('loadedpage')) : null;



if(loadedpage){
  if(loadedpage.full_slug == route.path){
    single.value = loadedpage
    store.dispatch('pages/setAsSingle', loadedpage);
    immediate = false
  }
}

if(localStorage.getItem('authenticated') == "true"){
  immediate = true
}

// You can watch the property for triggering some other action on change
watch(() => route.path, async () => {
  // Do something here...
  store.dispatch('loading/set',true);
  await setPageSingle(route)
  
  // Optionally you can set immediate: true config for the watcher to run on init
  }, { immediate: immediate }
);



  
</script>

<template>
  <div>
    <!-- PRIMARY PAGE -->
      
      <div v-if="single && Object.keys(errors).length == 0" :key="single.full_slug" class="mx-auto w-100">

        <Breadcrumbs :page="single" :key="single.full_slug" v-if="show_bread_class.includes(single.class)" />
         <!-- PRIMARY PAGE CONTENTS-->
        <contents-component 
          v-if="single.contents" 
          :key="single.full_slug" 
          :contents="single.contents">
        </contents-component>
        <v-container v-else>
          no content
        </v-container>

        <v-btn 
          color="success"  
          v-if="isEditor" 
          target="_blank" 
          :to="{name:'cms.pages.single', params:{id:single.id}}" 
          class="position-fixed z-index-100" 
          id="isEditor" 
          icon="mdi-pencil">
        </v-btn>
        <default-pre-footer v-if="show_prefooter_class.includes(single.class)" />
      </div>
      <div class="mx-auto w-100" v-else>
        <v-container v-if="!loading">
          <v-row v-if="Object.keys(errors).length">
            <v-col cols="12" class="text-center my-10 py-10">
              <h1 class="text-h3">{{errors.status}}</h1>
              <h2 class=" text-center ">
                {{errors.message}}
              </h2>
                <v-btn color="primary" variant="outlined" size="large" class="rounded-pill my-4" href="/">
                  <v-icon class="me-4">mdi-home</v-icon>
                 {{t('commons.back-home')}}
                </v-btn>
            </v-col>
          </v-row>
        </v-container>
        
        <v-container fluid v-if="!single && loading">
            <v-row align="center">
                <v-col cols="12" class="mx-auto" >
                    <v-skeleton-loader 
                    class="mx-auto"
                    elevation="2"
                    type="card-avatar, article, article,article, actions"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
        </v-container>  
        <default-pre-footer  />     
      </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'PrimaryPages',
  computed: {
        ...mapGetters({
            loading: 'loading/loading',
            single: 'pages/single',
            errors: 'pages/errors',
            isEditor: 'auth/isEditor',
            isAuthenticated: 'driveAuth/isAuthenticated',
            account: 'driveAuth/account'
        })
  },
  components:{

  },
  data: () => ({
   show_bread_class: ['editorial','car_catalog','car_archive','car_model','seo-parent','seo-location-brand','seo-location-type','seo-location'],
   show_prefooter_class: ['editorial','home','car_catalog','car_archive','car_model','search']
  }),
  watch:{
    errors(errors){
      if(Object.keys(errors).length){

        this.$gtm.trackEvent({
            event:'404',
            errors: this.errors,
            path: this.$route.path
        });
      
      }
      
    }
  },
  beforeCreate(){
    
  },
  mounted(){

    if(this.isAuthenticated && this.account){
      this.$gtm.trackEvent({
          event:'logstate',
          logged: true, //false se l'utente non è ancora loggato / registrato
          user :this.account
      });
    }

  },
  methods:{
    
  }
}
</script>
